import * as types from "./downloaderActionType";
import api from "./downloaderApi";
import {buildQueryString} from "../../../utils/url";

export function downloadFile(path, fileInfo, method = "GET", queryParams = undefined, showGeneratingToast = false){
    /**
     * Function that will dispatch the DOWNLOAD_FILE action.
     * fileInfo represents an identifier that can identify the
     * current downloads that we have.
     */


    let s3Path;

    if(queryParams){ // Condition used to identify the full url with queryparams for s3 downloads in our reducer.
        s3Path = path + buildQueryString(queryParams, path);
    }
    
    return {
        type : types.DOWNLOAD_FILE,
        fileInfo: fileInfo,
        promise: api.downloadFile(path, queryParams, method),
        path: s3Path ? s3Path : path,
        showGeneratingToast: showGeneratingToast
    };
}

export function clearError(path){
    return{
        type: types.CLEAR_ERROR_DOWNLOAD,
        path: path
    };
}

export function clearOngoing(path){
    return{
        type: types.CLEAR_ONGOING_DOWNLOAD,
        path: path
    };
}

export function clearSuccess(path){
    return{
        type: types.CLEAR_SUCCESS_DOWNLOAD,
        path: path
    };
}


// WEBPACK FOOTER //
// ./src/utils/downloader/downloaderActions.js